import React from 'react';
import type { CheckboxOptionType } from 'antd';
import { Radio, Space, RadioGroupProps } from 'antd';
import Typography from 'components/OnahTypography';
import classNames from 'classnames';
import OnahInputError from 'components/OnahInputError';

export type OnahRadioProps = {
    direction?:  'vertical' | 'horizontal';
    wrapperClassName?: string;
    labelClassName?: string;
    label?: string;
    error?: string;
} & RadioGroupProps;

const OnahRadio: React.FC<OnahRadioProps> = ({
    options = [],
    wrapperClassName,
    labelClassName,
    label,
    name,
    direction,
    error,
    className,
    ...props}) => {

    const buildOption = (option: string | number | CheckboxOptionType) => {
        if(typeof option === 'string' || typeof option === 'number') {
            return (<Radio value={option}>{option}</Radio>)
        } else {
            const {label, ...optionProps} = option;
            return (<Radio {...optionProps}>{label}</Radio>);
        }
    }

  return (
    <div className={wrapperClassName}>
        {label && (
            <Typography<HTMLLabelElement> type="label" htmlFor={name}  className={classNames("mb-1", labelClassName)}>{label}</Typography>
        )}
        <Radio.Group {...props} className={classNames(className, 'block')} name={name}>
        <Space direction={direction}>
            {options?.map(opt => buildOption(opt))}
        </Space>
        </Radio.Group>
        <OnahInputError error={error} showError={!!error}/>
    </div>
  );
};

export default OnahRadio;